export const menuData = [
	// {
	// 	permissionsModelId: "1",
	// 	meta: {
	// 		permissionsModelName: '首页',
	// 		icon: 'el-icon-s-home'
	// 	},
	// 	path: "/home",
	// 	children: []
	// }, 
	{
		permissionsModelId: "566dssddgd",
		permissionsModelName: '充电桩管理',
		icon: 'el-icon-s-home',
		children: [{
			permissionsModelId: "76545gf",
			permissionsModelName: '充电桩管理',
			icon: 'el-icon-s-home',
			path: "/chargeManage",
			children: []
		}]
	}, {
		permissionsModelId: "5",
		permissionsModelName: '运营管理',
		icon: 'el-icon-user',
		children: [{
				permissionsModelId: "5-1",
				permissionsModelName: '充电管理',
				icon: 'el-icon-s-home',
				path: "/chargingManage",
				children: []
			}, {
				permissionsModelId: "5-2",
				permissionsModelName: '充值管理',
				icon: 'el-icon-s-home',
				path: "/rechargeManage",
				children: []
			}, {
				permissionsModelId: "5-3",
				permissionsModelName: '充电金额管理',
				icon: 'el-icon-s-tools',
				path: "/chargeAmount",
				children: []
			},
			{
				permissionsModelId: "5-4",
				permissionsModelName: '充值金额管理',
				icon: 'el-icon-s-custom',
				path: "/rechargeAmount",
				children: []
			},
			{
				permissionsModelId: "5-5",
				permissionsModelName: '广告配置',
				icon: 'el-icon-s-custom',
				path: "/advertisementManage",
				children: []
			}
		]
	}, {
		permissionsModelId: "4",
		permissionsModelName: '运维管理',
		icon: 'el-icon-user',
		path: "",
		children: [{
				permissionsModelId: "4-1",
				permissionsModelName: '运维人员管理',
				icon: 'el-icon-s-tools',
				path: "/operationPersonerManage",
				children: []
			}, {
				permissionsModelId: "4-2",
				permissionsModelName: '故障管理',
				icon: 'el-icon-s-tools',
				path: "/hitchManage",
				children: []
			},
			{
				permissionsModelId: "4-3",
				permissionsModelName: '巡检记录',
				icon: 'el-icon-s-custom',
				path: "/tourManage",
				children: []
			},
			{
				permissionsModelId: "4-4",
				permissionsModelName: '用户故障反馈',
				icon: 'el-icon-s-custom',
				path: "/hitchFeedback",
				children: []
			}
		]
	}, {
		permissionsModelId: "6",
		permissionsModelName: '用户管理',
		icon: 'el-icon-user',
		path: "",
		children: [{
			permissionsModelId: "6-1",
			permissionsModelName: '用户管理',
			icon: 'el-icon-s-custom',
			path: "/userManage",
			children: []
		}]
	},
	{
		permissionsModelId: "7",
		permissionsModelName: '平台配置',
		icon: 'el-icon-user',
		path: "",
		children: [{
				permissionsModelId: "7-1",
				permissionsModelName: '权限管理',
				icon: 'el-icon-s-tools',
				path: "/permissionManage",
				children: []
			}, {
				permissionsModelId: "7-2",
				permissionsModelName: '账号管理',
				icon: 'el-icon-s-tools',
				path: "/accountManage",
				children: []
			},
			{
				permissionsModelId: "7-3",
				permissionsModelName: '参数配置',
				icon: 'el-icon-s-custom',
				path: "/parameterManage",
				children: []
			},
			{
				permissionsModelId: "7-4",
				permissionsModelName: '菜单配置',
				icon: 'el-icon-s-custom',
				path: "/menuConfiguration",
				children: []
			}
			// ,
			// {
			// 	permissionsModelId: "7-4",
			// 	meta: {
			// 		permissionsModelName: '设置',
			// 		icon: 'el-icon-s-tools'
			// 	},
			// 	path: "/set",
			// 	children: []
			// },
			// {
			// 	permissionsModelId: "7-5",
			// 	meta: {
			// 		permissionsModelName: '个人中心',
			// 		icon: 'el-icon-s-custom'
			// 	},
			// 	path: "/personNews",
			// 	children: []
			// }
		]
	}
]
export const tableData = [{
		eqpermissionsModelId: "120361651",
		eqName: "1号充电桩",
		station: "1号充电站",
		ip: "255.255.255.0",
		jack: "10",
		service: "运营商1号",
		eqStatus: "正常",
		runStatus: "未投用",
	},
	{
		eqpermissionsModelId: "120361651",
		eqName: "1号充电桩",
		station: "1号充电站",
		ip: "255.255.255.0",
		jack: "10",
		service: "运营商1号",
		eqStatus: "正常",
		runStatus: "未投用",
	},
	{
		eqpermissionsModelId: "120361651",
		eqName: "1号充电桩",
		station: "1号充电号充电站号充电站站",
		ip: "255.255.255.0",
		jack: "10",
		service: "运营商1号",
		eqStatus: "正常",
		runStatus: "未投用",
	},
	{
		eqpermissionsModelId: "120361651",
		eqName: "1号充电桩",
		station: "1号充电站",
		ip: "255.255.255.0",
		jack: "10",
		service: "运营商1号",
		eqStatus: "正常",
		runStatus: "未投用",
	},
	{
		eqpermissionsModelId: "120361651",
		eqName: "1号充电桩",
		station: "1号充电站",
		ip: "255.255.255.0",
		jack: "10",
		service: "运营商1号",
		eqStatus: "正常",
		runStatus: "未投用",
	}
]


export const stationList = [{
		name: "1号充电站",
		equipmentNum: 15,
		errNum: 0,
		adress: "江苏省南京市江宁区胜太西路天琪雅居"
	},
	{
		name: "2号充电站",
		equipmentNum: 15,
		errNum: 0,
		adress: "江苏省南京市江宁区胜太西路天琪雅居"
	},
	{
		name: "3号充电站",
		equipmentNum: 15,
		errNum: 0,
		adress: "江苏省南京市江宁区胜太西路天琪雅居"
	}
]
